import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Hero from '../../components/Hero';
import PageSection from '../../components/Page/PageSection';
import SectionTeaser from '../../components/Teaser/Section';
import TextImageTeaser from '../../components/Teaser/TextImage';
import Button from '../../components/Button';

import Milk from './milk.png';

import s from './Home.css';

class Home extends React.Component {
  render() {
    return (
      <div>
        <Hero />

        <PageSection>
          <SectionTeaser
            title={'Testa här om du kan använda ett kostråd'}
            text={
              <p>
                {`
                Vill du kommunicera kostråd på eller invid enskilda produkter?
                Använd vårt test för att se om den produkt och det kostråd du tänkt kombinera passar ihop.
                `}
              </p>
            }
            button={
              <Button to="/testet" primary>
                {'Starta testet'}
              </Button>
            }
            svg={<img alt="" src={Milk} height="84" width="64" />}
          />

          <SectionTeaser
            title={'Få fördjupning i faktabanken'}
            text={
              <div>
                <p>
                  {`
                    Faktabanken innehåller fördjupad information för att ge dig ett bra underlag när du bedömer
                    om den produkt och det kostråd du tänkt kombinera är lämpliga att använda. Här hittar du t ex
                    länkar till relevant lagstiftning. Testet ovan hänvisar till olika delar i faktabanken för att
                    underlätta dina val när du klickar dig fram i testet.
                  `}
                </p>
                <p>
                  {`
                    Om du vill kommunicera kostråd för en hel livsmedelsgrupp läser du under alla rubriker i
                    faktabanken för att förvissa dig om att det kostråd och den produktgrupp du valt passar ihop och
                    kan användas. Testet ovan är inte anpassat för hela livsmedelsgrupper.
                  `}
                </p>
              </div>
            }
            button={
              <Button to="/faktabank" link>
                {'Gå till faktabanken'}
              </Button>
            }
          />
        </PageSection>

        <PageSection inverse>
          <TextImageTeaser
            title="Bidra till hälsosamma matvanor!"
            image={
              <img
                alt="Grönsaker"
                src="https://s3-eu-west-1.amazonaws.com/kostradsguiden/gronsaker.jpg"
                height="500"
                width="500"
              />
            }
            text={
              <div>
                <p>
                  {`
                    Vi som producerar livsmedel är viktiga aktörer som kan bidra till hälsosamma matvanor hos den svenska befolkningen.
                    Att livsmedelsindustrins insatser behövs råder det ingen tvekan om. Exempelvis äter för få tillräckligt med fullkorn,
                    fisk och skaldjur samt grönsaker och frukt.
                  `}
                </p>
                <p>
                  {`
                    Bra matvanor och fysisk aktivitet håller oss friska och minskar risken för så kallade välfärdssjukdomar; hjärt-kärlsjukdom,
                    typ 2-diabetes, cancer och fetma. Mat och fysisk aktivitet är inte de enda faktorerna som påverkar hälsotillståndet,
                    men de utgör en del som var och en har möjlighet att påverka själv.
                  `}
                </p>
              </div>
            }
          />
          <TextImageTeaser
            title="Inspirera konsumenten att välja rätt"
            image={
              <img
                alt="Handla"
                src="https://s3-eu-west-1.amazonaws.com/kostradsguiden/handla.jpg"
                height="500"
                width="500"
              />
            }
            text={
              <div>
                <p>
                  {`
                    Ett sätt för livsmedelsindustrin att inspirera till hälsosamma matvanor är att kommunicera Livsmedelsverkets
                    kostråd – råd som vilar på vetenskaplig grund. Det kan ske förpackningen och i butikshyllan, i annonser, på hemsidor och i TV-reklam.
                  `}
                </p>
                <p>
                  {`
                    Denna guide innehåller riktlinjer att följa när du använder kostråden och ger dig möjlighet
                    att anpassa budskapen till olika målgrupper och sammanhang. Guiden, som tagits fram av
                  `}
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://livsmedelsforetagen.se/"
                  >
                    {'Livsmedelsföretagen'}
                  </a>
                  {`,
                    ska hjälpa dig som arbetar i livsmedelsindustrin att göra rätt när du använder kostråd i märkning och annan marknadsföring.
                    Vi vill även inspirera till att ta fram nya produkter som märks med kostråden och som hjälper konsumenten till hälsosamma val.
                  `}
                </p>
              </div>
            }
            inverse
          />
        </PageSection>
      </div>
    );
  }
}

export default withStyles(s)(Home);



// WEBPACK FOOTER //
// ./src/routes/home/Home.js